import React from "react";
import style from "./WeatherCurrent.module.scss";
import clearDay from "./assets/clearDay.svg";
import uvIcon from "./assets/uv.svg";
import humidityIcon from "./assets/Humidity.svg";
import precipitationIcon from "./assets/Precipitation.svg";
export function WeatherCurrent(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: style.container
  }, /*#__PURE__*/React.createElement("div", {
    className: style.upperLayer
  }, /*#__PURE__*/React.createElement("img", {
    src: clearDay,
    alt: "Weather Image",
    className: style.weatherImage
  }), /*#__PURE__*/React.createElement("div", {
    className: style.weatherInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: style.temperature
  }, props.temperature), /*#__PURE__*/React.createElement("div", {
    className: style.description
  }, props.summary_text))), /*#__PURE__*/React.createElement("div", {
    className: style.middleLayer
  }, /*#__PURE__*/React.createElement("div", {
    className: style.weatherItem
  }, /*#__PURE__*/React.createElement("img", {
    src: uvIcon,
    alt: "UV",
    className: style.icon
  }), /*#__PURE__*/React.createElement("div", {
    className: style.name
  }, "UV"), /*#__PURE__*/React.createElement("div", {
    className: style.value
  }, props.uv_value)), /*#__PURE__*/React.createElement("div", {
    className: style.weatherItem
  }, /*#__PURE__*/React.createElement("img", {
    src: humidityIcon,
    alt: "Humidity",
    className: style.icon
  }), /*#__PURE__*/React.createElement("div", {
    className: style.name
  }, "Humidity"), /*#__PURE__*/React.createElement("div", {
    className: style.value
  }, props.humidity_value)), /*#__PURE__*/React.createElement("div", {
    className: style.weatherItem
  }, /*#__PURE__*/React.createElement("img", {
    src: precipitationIcon,
    alt: "Precipitation",
    className: style.icon
  }), /*#__PURE__*/React.createElement("div", {
    className: style.name
  }, "Precipitation"), /*#__PURE__*/React.createElement("div", {
    className: style.value
  }, props.precipitation_value))), /*#__PURE__*/React.createElement("div", {
    className: style.lowerLayer
  }, props.suggestion_text));
}